<template>
    <div class="apprentice-simple-card dashboard-invites-widget">
        <div class="component-title">
            <h5 class="title">{{ $t('dashboard.requests_under_consideration') }}</h5>
        </div>

        <!--        groepjesmaaktool uitnodigingen-->
        <div class="invites">
            <div
                class="invite"
                v-for="invite in invites">
                <div class="icon d-none d-xl-flex">
                    <i class="fad fa-fw btn-hourglass-start btn-pending"></i>
                </div>
                <div class="title">
                    {{ invite.group.name }}
                    <div class="invite-type muted-text">{{ $t('dashboard.request_submitted') }}</div>
                </div>

                <a
                    class="clickable"
                    :href="toGroupPairStatusPage(invite)"></a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-dashboard-group-pair-status-component',
    props: {
        invitesIn: {
            type: Array,
        },
    },
    data() {
        return {
            invites: this.invitesIn,
        };
    },
    methods: {
        toGroupPairStatusPage(invite) {
            return this.routes.groupPairStatus(invite.group_id);
        },
    },
};
</script>

<style scoped lang="scss">
.btn-pending {
    color: $warning;

    &:hover {
        color: $warning;
    }
}

.dashboard-invites-widget {
    .info-text {
        color: $text-muted-color;
        font-size: $default-font-size;
    }

    .info-text,
    .invite {
        margin-bottom: map-get($grid-gutter-spacing, 'ten');
    }

    .invite {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        font-size: 1.3125rem;
        position: relative;
        padding-top: map-get($grid-gutter-spacing, 'ten');

        .icon {
            align-self: center;
            padding: map-get($grid-gutter-spacing, 'ten');
            background: $secondary-background-color;
            border-radius: $border-radius-content;
            color: $primary;
            height: 40px;
        }

        .title {
            font-size: $default-font-size;
            font-family: $headings-font-family;
            line-height: 1;
            align-self: center;
        }

        .invite-show,
        .invite-action {
            align-self: center;
            margin-left: auto;

            .btn {
                font-size: 1.3125rem;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .invite {
        .title {
            margin-right: map-get($grid-gutter-spacing, 'ten');
        }
    }

    .page-wrapper.navbar-toggled {
        .invite {
            .title {
                margin-left: map-get($grid-gutter-spacing, 'ten');
            }

            .icon {
                display: flex !important;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .dashboard-invites-widget {
        .invite {
            .title {
                margin-left: map-get($grid-gutter-spacing, 'fifteen');
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
}
</style>
